<template>
  <div class="titulo">
    <div class="margem">
      <h2 class="selecionado">Tarefas</h2>
    </div>
  </div>
  <div v-if="showTarefas" class="margem">
    <FiltrosTarefas :subordinados="subordinados" v-model:usuario-tarefas="usuarioTarefas"
      v-model:periodo-inicio="periodoInicio" v-model:periodo-fim="periodoFim"
      :buscar-tarefas-sem-data="buscarTarefasSemData" v-model:status-tarefas="statusTarefas" v-model:origem="origem"
      v-model:status-origem="statusOrigem" :loading="loading"
      :pode-baixar-xml="dadosUsuario?.grupo.includes('Diretoria') || dadosUsuario?.funcionalidade_id?.includes(116)"
      :loading-xml="loadingXml" @toggle-sem-data="onToggleSemData" @toggle-atrasadas="toggleAtrasadas"
      @buscar="getTarefas" @baixar-xml="baixarXML()" />
    <br>
    <div class="bloco margem">
      <ResumoHP :somatoria-h-p="somatoriaHP" :total="tarefas.length"
        :pode-adicionar-tarefa="dadosUsuario?.funcionalidade_id?.includes(128) || dadosUsuario?.funcionalidade_id?.includes(116)"
        @adicionar-tarefa="showModalNovaTarefa = true" />
      <table class="tabela" v-if="!loading" role="table" aria-label="Lista de tarefas">
        <tbody>
          <tr>
            <th scope="col"></th>
            <th scope="col" @click="ordenarLista('pcm_codigo')" class="header"> Nº <span
                v-if="sortKey === 'pcm_codigo'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
            <th scope="col" @click="ordenarLista('responsavel_nome')" class="header"> Responsável <span
                v-if="sortKey === 'responsavel_nome'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
            <th scope="col"> Tipo </th>
            <th scope="col"> Origem </th>
            <th scope="col"> Pacote de trabalho </th>
            <th scope="col"> Sprint </th>
            <th scope="col"> Descrição </th>
            <th scope="col" @click="ordenarLista('HP')" class="header"> H.P. <span v-if="sortKey === 'HP'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
            <th scope="col"> início Previsto </th>
            <th scope="col" @click="ordenarLista('dtFim')" class="header"> Fim Previsto <span
                v-if="sortKey === 'dtFim'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
            <th scope="col" @click="ordenarLista('dtFimReal')" class="header"
              v-if="statusTarefas.map(i => i.valor).includes('Concluído')"> Fim Real <span
                v-if="sortKey === 'dtFimReal'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
            <th scope="col" @click="ordenarLista('status')" class="header"> Status <span v-if="sortKey === 'status'"><i
                  :class="sortOrder === 'asc' ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"></i></span>
            </th>
          </tr>
          <tr style="text-align: center;" v-for="item in tarefasFiltradas" :key="item"
            :id="destaqueTarefaId && item.id === destaqueTarefaId ? 'tarefa-destaque' : undefined"
            @mousedown="rowMouseDownX = $event.clientX; rowMouseDownY = $event.clientY"
            @click="onRowClick(item, $event)"
            :class="{ 'tarefa-destaque': destaqueTarefaId && item.id === destaqueTarefaId }"
            :style="{ 'background-color': item.isRead === '0' && item.id !== destaqueTarefaId ? 'var(--cor-cinza)' : '' }">
            <td><i class="bi-patch-exclamation-fill" v-if="isRecent(item.created_at)"
                style="color: var(--cor-primaria); font-size: 16px;" title="Tarefa Adicionada Recentemente"></i>
            </td>
            <td style="white-space: nowrap;">
              {{ item.codigo }}</td>
            <td>
              <span> {{ nomeEsobrenome(item.responsavel_nome) }} </span>
            </td>
            <td>{{ item.tipo_nome ?? '-' }}</td>
            <td class="clicavel" @click.stop="onRowClick(item, $event)">
              <div style="display: flex; flex-flow: column">
                <span>{{ item.pcm_codigo }}</span><span>{{ item.nome }}</span>
              </div>
            </td>
            <td>{{ item.entrega_nome ?? '-' }}</td>
            <td>{{ item.sprint_nome ?? '-' }}</td>
            <td style="text-align: left; cursor: pointer" class="clicavel">
              <div class="alinha-v">
                <div :title="item.descricao"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis">
                  {{ item.descricao }} </div>
                <i v-if="item.anexos.length > 0" style="font-size: 18px;" title="Esta tarefa possui um anexo"
                  class="bi bi-paperclip"></i>
              </div>
            </td>
            <td>
              <!-- :disabled="idUsuario !== item.coordenador_id" -->
              <select :disabled="item.responsavel_id !== idUsuario" v-model="item.HP" class="HP"
                @change="editarTarefa(item.tipo, 'HP', item.id, item.HP)"
                style="width: 2.5rem; height: 2.5rem;text-align: center; border-radius: 50%; padding: 0; opacity: 1;">
                <option hidden>0</option>
                <option hidden :value="item.HP">{{ item.HP }}</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>5</option>
                <option>8</option>
                <option>13</option>
                <option>21</option>
                <option>34</option>
                <option>55</option>
                <option>89</option>
                <option>144</option>
                <option>233</option>
              </select>
            </td>
            <td @click.stop>
              <div style="display: flex; gap: 5px;">
                <!-- :readonly="idUsuario !== item.coordenador_id" -->
                <input type="date" v-model="item.dtInicio" :readonly="item.responsavel_id !== idUsuario"
                  style="background-color: transparent;"
                  @change="editarTarefa(item.tipo, 'dtInicio', item.id, item.dtInicio)">
              </div>
            </td>
            <td @click.stop>
              <div class="gestao-fim-previsto">
                <div style="display: flex; gap: 5px;">
                  <!-- :readonly="idUsuario !== item.coordenador_id" -->
                  <input type="date" v-model="item.dtFim" :readonly="item.responsavel_id !== idUsuario"
                    style="background-color: transparent;"
                    @change="editarTarefa(item.tipo, 'dtFim', item.id, item.dtFim)">
                  <i v-if="isTarefaAtrasada(item)"
                    class="bi bi-exclamation-diamond-fill" style="font-size: 18px; color: var(--cor-erro);"
                    title="Tarefa Atrasada"></i>
                </div>
                <span v-if="item.tipo === 999 && exibirFimPrevistoOriginal(item, item.dtFim)"
                  class="chip bg-erro gestao-fim-previsto-original" :title="tituloFimPrevistoOriginal(item)">
                  Original: {{ formatarDataBr(fimPrevistoOriginal(item)) }}
                </span>
              </div>
            </td>
            <td v-if="statusTarefas.map(i => i.valor).includes('Concluído')"> {{ item.dtFimReal ?
              `${formatarDataHora(item.dtFimReal).split("-")[2]}/${formatarDataHora(item.dtFimReal).split("-")[1]}/${formatarDataHora(item.dtFimReal).split("-")[0]}`
              : "-" }} </td>
            <td @click.stop style="min-width: 12rem;">
              <div style="position: relative">
                <v-progress-linear :color="item.status === 'Cancelada'
                  ? 'red'
                  : item.status === 'Concluído'
                    ? 'var(--cor-sucesso)'
                    : item.status === 'Pendente'
                      ? 'var(--cor-alerta)'
                      : item.status === 'Em andamento' || item.status === 'Em andamento 25%' || item.status === 'Em andamento 50%' || item.status === 'Em andamento 75%'
                        ? 'var(--cor-ok)'
                        : 'red'
                  " :model-value="item.status === 'Concluído' || item.status === 'Cancelada' ? 100 : item.status === 'Pendente' ? 100 : item.status.split(' ')[2] ? item.status.split(' ')[2].slice(0, 2) : 2
                    " style="border: 1px solid var(--cor-fonte-fraca); border-radius: 25px; height: 2rem">
                </v-progress-linear>
                <select :title="tarefaTemResponsavel(item) ? item.status : MENSAGEM_TAREFA_SEM_RESPONSAVEL"
                  :disabled="!tarefaTemResponsavel(item)"
                  :style="{ color: item.status === 'Concluído' ? 'var(--cor-bg)' : 'black' }"
                  style="
                        border: none;
                        padding-left: 0.5rem;
                        position: absolute;
                        top: 0;
                        left: 0rem;
                        outline: none;
                        border-radius: 25px;
                        height: 2rem;
                        text-align: center;
                        background-color: transparent;
                        padding-top: 0rem;
                        padding-bottom: 0rem;
                        opacity: 1;
                      " @change="editarTarefa(item.tipo, 'status', item.id, item.status)" v-model="item.status">
                  <option value="" hidden></option>
                  <option style="color: rgb(255, 145, 0)" value="Pendente">A iniciar</option>
                  <option style="color: rgb(0, 47, 255)" :value="'Em andamento'">Em andamento 0%</option>
                  <option style="color: rgb(0, 47, 255)" value="Em andamento 25%">Em andamento 25%</option>
                  <option style="color: rgb(0, 47, 255)" value="Em andamento 50%">Em andamento 50%</option>
                  <option style="color: rgb(0, 47, 255)" value="Em andamento 75%">Em andamento 75%</option>
                  <option style="color: rgb(0, 192, 0)">Concluído</option>
                  <option style="color: red">Cancelada</option>
                </select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="loading">
        <div></div>
      </div>
    </div>
  </div>
  <ModalEditarTarefa v-if="tarefaEditada" :isAuditor="dadosUsuario?.funcionalidade_id.includes(116)"
    :isCoordenador="idUsuario === tarefaEditada.coordenador_id || (tarefaEditada.tipo === 1001 && idUsuario === tarefaEditada.responsavel_id)"
    :propTarefa="tarefaEditada" :usuarios="usuarios"
    :subordinados="subordinados" @fecharModal="tarefaEditada = null" />
  <ModalAdicionarTarefa v-if="showModalNovaTarefa" @close="showModalNovaTarefa = false" />
</template>
<script>
import { getDados } from "@/services/serviceFuncionalidades";
import { consultarSetores } from "@/services/usuario-setor";
import {
  listarTarefasUsuario,
  baixarRelatorioTarefasExcel,
  listarUsuarios,
  listarSubordinadosPorResponsavel,
  atualizarSprintTarefa,
  atualizarPlanoAcaoTarefa,
  atualizarProtocoloTarefa,
  atualizarTarefaReuniaoGoogle,
} from "@/services/serviceGestaoTarefas";
import { sso } from "roboflex-thalamus-sso-lib";
import serviceFunções from "@/services/serviceFunções";
import Cookies from 'js-cookie'
import ModalEditarTarefa from '@/components/Modais/projetos/ModalEditarTarefa.vue';
import ModalAdicionarTarefa from "@/components/Modais/ModalAdicionarTarefa.vue";
import dayjs from "dayjs";
import { useApiError } from "@/composables/useApiError";
import { useOrdenacaoColuna } from "@/composables/useOrdenacaoColuna";
import FiltrosTarefas from "@/components/Gestão/FiltrosTarefas.vue";
import ResumoHP from "@/components/Gestão/ResumoHP.vue";
import {
  tarefaTemResponsavel,
  MENSAGEM_TAREFA_SEM_RESPONSAVEL,
} from '@/utils/tarefaStatus';
import { formatarDataBr, dataParaInput } from '@/utils/date';
import { exibirFimPrevistoOriginal, fimPrevistoOriginal, tituloFimPrevistoOriginal } from '@/utils/fim-previsto-historico';

export default {
  name: "gestaoTarefas",

  components: {
    ModalEditarTarefa,
    ModalAdicionarTarefa,
    FiltrosTarefas,
    ResumoHP,
  },

  setup() {
    const { handleError } = useApiError({ message: 'Não foi possível carregar as tarefas.' });
    const { sortKey, sortOrder, toggleOrdenacao } = useOrdenacaoColuna('status', 'asc');
    const formatarDataHora = (valor) => {
      return serviceFunções.formatarDataHora(valor);
    };

    const nomeEsobrenome = (nome) => {
      return serviceFunções.nomeEsobrenome(nome);
    };

    return {
      handleError,
      formatarDataHora,
      nomeEsobrenome,
      sortKey,
      sortOrder,
      toggleOrdenacao,
    };
  },

  data() {
    return {
      loading: true,
      setores: [],
      showModalNovaTarefa: false,
      tarefaEditada: null,
      showTarefas: true,
      showEntregas: false,
      tarefasFiltradas: "",
      tarefasSemDataFiltradas: "",
      buscarTarefasSemData: false,
      idUsuario: null,
      dadosUsuario: null,
      subordinados: [],

      usuarioTarefas: null,
      statusOrigem: [{ valor: 'Pendente' }, { valor: "Aprovado" }, { valor: "Em andamento" }, { valor: "Concluído" }],
      statusTarefas: [{ label: 'A iniciar', valor: "Pendente" }, { label: 'Em andamento', valor: "Em andamento" }],
      periodoInicio: "",
      periodoFim: "",

      origem: [
        {
          valor: 999,
          label: "Projetos",
        },
        {
          valor: 1000,
          label: "PAP",
        },
        {
          valor: 1,
          label: "TNC",
        },
        {
          valor: 3,
          label: "RAP",
        },
        {
          valor: 4,
          label: "OS",
        },
        {
          valor: 5,
          label: "Plano de Ação",
        },
        {
          valor: 6,
          label: 'Rotina'
        },
        {
          valor: 7,
          label: 'CRM',
        },
        { valor: 8, label: 'PAP Novo' },
        { valor: 1001, label: 'Reunião' },
      ],

      usuarios: null,
      showComentarioTarefa: false,
      tarefas: [],
      tarefasSemdata: [],
      somatoriaHP: [0, 0, 0],
      rowMouseDownX: 0,
      rowMouseDownY: 0,
      loadingXml: false,
      storageFiltrarTarefa: null,
      /** ID da tarefa a destacar quando a página foi aberta a partir do portal (query destaque_tarefa_id). */
      destaqueTarefaId: null,
    };
  },
  created() {
    const usuarioLogado = sso.getUsuarioLogado();
    this.idUsuario = usuarioLogado.id;

    const query = this.$route?.query || {};
    const fromPortal = query.fromPortal === '1';

    if (fromPortal) {
      // Filtros vindos do portal: sobrescrevem filtro salvo e sessionStorage (sem periodoInicio = mostra antigas/atrasadas)
      if (query.periodoFim) this.periodoFim = query.periodoFim;
      if (query.idUser) {
        const ids = String(query.idUser).split(',').map((id) => ({ valor: Number(id.trim()) }));
        this.usuarioTarefas = ids;
      } else {
        this.usuarioTarefas = [{ valor: usuarioLogado.id }];
      }
      if (query.statusTarefas) {
        const valores = String(query.statusTarefas).split(',').map((s) => s.trim());
        const statusMap = { 'Pendente': 'A iniciar', 'Em andamento': 'Em andamento', 'Atrasado': 'Atrasado' };
        this.statusTarefas = valores.map((v) => ({ label: statusMap[v] || v, valor: v }));
      }
      const destaqueId = query.destaque_tarefa_id;
      if (destaqueId) this.destaqueTarefaId = Number(destaqueId);
    } else {
      const filtroSalvo = this.restaurarFiltro();
      if (filtroSalvo) {
        if (filtroSalvo.usuarioTarefas?.length) this.usuarioTarefas = filtroSalvo.usuarioTarefas;
        if (filtroSalvo.periodoInicio !== undefined) this.periodoInicio = filtroSalvo.periodoInicio;
        if (filtroSalvo.periodoFim !== undefined) this.periodoFim = filtroSalvo.periodoFim;
        if (filtroSalvo.statusTarefas?.length) this.statusTarefas = filtroSalvo.statusTarefas;
        if (filtroSalvo.statusOrigem?.length) this.statusOrigem = filtroSalvo.statusOrigem;
        if (filtroSalvo.origem?.length) this.origem = filtroSalvo.origem;
        if (typeof filtroSalvo.buscarTarefasSemData === 'boolean') this.buscarTarefasSemData = filtroSalvo.buscarTarefasSemData;
      } else {
        const storageFiltrarTarefa = sessionStorage.getItem('storageFiltrarTarefas');
        if (storageFiltrarTarefa === 'pendente') this.statusTarefas = [{ label: 'A iniciar', valor: 'Pendente' }];
        else if (storageFiltrarTarefa === 'emAndamento') this.statusTarefas = [{ label: 'Em andamento', valor: 'Em andamento' }];
        else if (storageFiltrarTarefa === 'atrasada') this.statusTarefas = [{ label: 'Atrasado', valor: 'Atrasado' }];
        this.usuarioTarefas = [{ valor: usuarioLogado.id }];
      }
    }
  },

  async mounted() {
    await this.getSetores();
    this.carregarPermissoes();
    this.getTarefas();
  },

  methods: {
    tarefaTemResponsavel,
    MENSAGEM_TAREFA_SEM_RESPONSAVEL,
    isRecent(created) {
      const data = dayjs(created)
      const agora = dayjs()
      const diffDias = agora.diff(data, 'day')
      return diffDias <= 3
    },
    formatarDataBr,
    dataParaInput,
    fimPrevistoOriginal,
    exibirFimPrevistoOriginal,
    tituloFimPrevistoOriginal,
    isTarefaAtrasada(tarefa) {
      if (!tarefa?.dtFim || tarefa.status === 'Concluído' || tarefa.status === 'Cancelada') return false;
      const d = new Date();
      const hoje = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      return hoje > String(tarefa.dtFim).slice(0, 10);
    },
    abrirProjeto(projetoId) {
      if (!projetoId) return;
      this.$router.push({
        name: 'projetoView',
        params: { idProjeto: String(projetoId) },
      });
    },
    onRowClick(item, event) {
      const dx = Math.abs(event.clientX - this.rowMouseDownX)
      const dy = Math.abs(event.clientY - this.rowMouseDownY)
      if (dx < 6 && dy < 6) this.irParaOrigem(item)
    },
    irParaOrigem(item) {
      const tipo = item.origem_tabela;
      const id = item.origem_id;

      // Temporário: tarefas de reunião (tipo 1001) abrem no modal em vez de ir à origem.
      // Não marcar como lida aqui: o PATCH usa reuniao_id e falha com "Reunião não encontrada" se o evento
      // não estiver na agenda do usuário (mesmo motivo do fluxo reuniaoGoogle abaixo não chamar isRead).
      if (item.tipo === 1001) {
        this.tarefaEditada = item;
        return;
      }

      // Tarefas de reunião Google: navegar sem marcar como lida (evita toast se a reunião não estiver na agenda do usuário)
      if (tipo === 'reuniaoGoogle') {
        this.$router.push({
          name: 'listaReunioes',
          query: { destaque_tarefa_id: item.id, reuniao_id: id },
        });
        return;
      }

      this.editarTarefa(item.tipo, 'isRead', item.id, true);
      item.isRead = '1';

      // Tarefas do tipo 7 (CRM) abrem no modal em vez de redirecionar para a origem
      if (item.tipo === 7) {
        this.tarefaEditada = item;
        return;
      }

      if (tipo === 'projeto') {
        const query = { destaque_tarefa_id: item.id };
        if (item.entrega_id) query.entrega_id = item.entrega_id;
        if (item.sprint_id) query.sprint_id = item.sprint_id;
        this.$router.push({
          name: 'projetoView',
          params: { idProjeto: String(id) },
          query,
        });
        return;
      }

      if (tipo === 'protocolo') {
        const query = { destaque_tarefa_id: item.id };
        if (item.tipo == 6) {
          this.$router.push({ name: 'grupoView', params: { id: String(id) }, query });
        } else if (item.tipo === 7) {
          this.$router.push({ name: 'reuniaoView', params: { id: String(id) }, query });
        } else {
          this.$router.push({ name: 'visualizacaoProtocolo', params: { idProtocolo: String(id) }, query });
        }
        return;
      }

      if (tipo === 'planoAcao') {
        this.$router.push({
          name: 'visualizacaoPAP',
          params: { idPAP: String(id) },
          query: { destaque_tarefa_id: item.id },
        });
        return;
      }

      this.abrirOrigem(item);
    },
    abrirOrigem(item) {
      const tipo = item.origem_tabela;
      const id = item.origem_id
      let caminho = '';
      let url = process.env.NODE_ENV === 'development' ? 'http://projetos-homologacao.thalamus.ind.br/#/' : 'https://projetos.thalamus.ind.br/#/'

      switch (tipo) {
        case 'projeto':
          caminho = `projeto/${id}`;
          break;
        case 'planoAcao':
          caminho = `PAP/${id}`;
          break;
        case 'protocolo':
          if (item.tipo == 6) {
            caminho = `grupo/${id}`
          }
          else if (item.tipo === 7) {
            caminho = `reuniao/${id}`
          } else {
            caminho = `protocolo/${id}`;
          }
          break;
        case 'reuniaoGoogle':
          caminho = `reunioes-google`;
          break;
        default:
          console.warn('Tipo de origem desconhecido:', tipo);
          return;
      }
      window.open(url + caminho, '_blank');
    },
    fecharModal(tarefa) {
      const index = this.tarefasFiltradas.findIndex(item => item.id === tarefa.id);
      if (index !== -1) {
        this.tarefasFiltradas[index] = tarefa;
      }
      this.tarefaEditada = null
    },
    editarTarefa(origem, itemAlterado, idBacklog, novoValor) {
      if (itemAlterado === 'status') {
        const item = this.tarefasFiltradas.find((t) => t.id === idBacklog)
          || this.tarefas.find((t) => t.id === idBacklog)
        if (item && !tarefaTemResponsavel(item)) {
          window.alert(MENSAGEM_TAREFA_SEM_RESPONSAVEL)
          return
        }
      }
      switch (origem) {
        case 999:
          this.editarBacklog(itemAlterado, idBacklog, novoValor)
          break;
        case 1000:
          this.editarBacklogPlanodeAção(itemAlterado, idBacklog, novoValor)
          break;
        case 1001:
          this.editarTarefaReuniao(itemAlterado, idBacklog, novoValor)
          break;
        default:
          this.editarBacklogProtocolo(itemAlterado, idBacklog, novoValor)
      }
    },
    verProtocolo(id) {
      this.$router.push({ name: "visualizacaoProtocolo" });
      sessionStorage.setItem("idProjeto", id);
    },
    verPAP(id) {
      var project = this.PAPs.data.find(item => item.id === id)
      if (project) {
        Cookies.set('projectDetails', JSON.stringify({
          idProjeto: project.id,
          nome: project.nome,
          pcm_codigo: project.pcm_codigo,
          pcm_id: project.pcm_id,
          perfil: 1
        }), { expires: 1 })
        this.$router.push({ name: 'PA' })
      }
      Cookies.set('projectDetails', JSON.stringify({
        idProjeto: project.id,
        nome: project.nome,
        pcm_codigo: project.pcm_codigo,
        pcm_id: project.pcm_id,
        perfil: 1
      }), { expires: 1 })
      this.$router.push({ name: 'PA' })
    },
    definirPeriodo() {
      if (this.buscarTarefasSemData === false) {
        this.periodoFim = "";
      } else if (this.buscarTarefasSemData === true) {
        this.periodoInicio = "";
        this.periodoFim = "semData";
      }
    },
    onToggleSemData() {
      this.buscarTarefasSemData = !this.buscarTarefasSemData;
      this.definirPeriodo();
    },
    toggleAtrasadas() {
      if (this.statusTarefas.map(i => i.valor).includes('Atrasado')) {
        this.statusTarefas = this.statusTarefas.filter(item => item.valor !== 'Atrasado');
      } else {
        this.statusTarefas.push({ valor: 'Atrasado' });
      }
    },

    somarHP() {
      let somaPendentes = 0;
      let somaEmAndamento = 0;
      let somaConcluidos = 0;

      this.tarefas.forEach((item) => {
        if (item.status === "Pendente") {
          if (item.HP) {
            somaPendentes += parseInt(item.HP);
          }
        }
        if (item.status === "Em andamento" || item.status === "Em andamento 25%" || item.status === "Em andamento 50%" || item.status === "Em andamento 75%") {
          if (item.HP) {
            somaEmAndamento += parseInt(item.HP);
          }
        }
        if (item.status === "Concluído") {
          if (item.HP) {
            somaConcluidos += parseInt(item.HP);
          }
        }
      });

      this.somatoriaHP = [somaPendentes, somaEmAndamento, somaConcluidos];
    },

    getMondayAndFriday() {
      const today = new Date();
      const day = today.getDay();
      const diffToMonday = today.getDate() - day + (day === 0 ? -6 : 1); // Ajuste para que domingo seja -6
      const monday = new Date(today.setDate(diffToMonday));
      const friday = new Date(monday);
      friday.setDate(monday.getDate() + 4); // Adiciona 4 dias para obter sexta-feira

      return {
        Segunda: monday.toISOString().split("T")[0], // Formata a data para YYYY-MM-DD
        Sexta: friday.toISOString().split("T")[0], // Formata a data para YYYY-MM-DD
      };
    },

    async editarBacklogPlanodeAção(itemAlterado, idBacklog, novoValor) {
      try {
        await atualizarPlanoAcaoTarefa(idBacklog, {
          usuario_id: this.idUsuario,
          [itemAlterado]: novoValor,
        });
        if (itemAlterado === "status") {
          await this.definirInicioFimRealPlanodeAção(idBacklog, novoValor);
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async editarBacklogProtocolo(itemAlterado, idTarefa, novoValor) {
      try {
        await atualizarProtocoloTarefa(idTarefa, {
          usuario_id: this.idUsuario,
          [itemAlterado]: novoValor,
        });
        if (itemAlterado === "status") {
          await this.definirInicioFimRealProtocolo(idTarefa, novoValor);
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async editarTarefaReuniao(itemAlterado, idTarefa, novoValor) {
      const item = this.tarefasFiltradas.find((t) => t.id === idTarefa && t.tipo === 1001);
      if (!item || !item.origem_id) return;
      const reuniaoId = item.origem_id;
      let payload = {};
      if (itemAlterado === 'status') {
        // Envia a string com percentual igual às outras tarefas (ex.: "Em andamento 25%")
        payload.status = novoValor ?? 'Pendente';
      } else if (itemAlterado === 'dtInicio') {
        payload.dt_inicio = novoValor || null;
      } else if (itemAlterado === 'dtFim') {
        payload.dt_fim = novoValor || null;
      } else if (itemAlterado === 'isRead') {
        payload.is_read = !!novoValor;
      }
      if (Object.keys(payload).length === 0) return;
      try {
        await atualizarTarefaReuniaoGoogle(reuniaoId, idTarefa, payload);
        Object.assign(item, { ...payload, [itemAlterado]: novoValor });
        if (itemAlterado === 'isRead') item.isRead = novoValor ? '1' : '0';
      } catch (error) {
        this.handleError(error);
      }
    },

    async definirInicioFimRealProtocolo(idTarefa, status) {
      const d = new Date();
      const data = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-");
      const tarefa = this.tarefas.find((item) => item.id === idTarefa);
      const emAndamento = ["Em andamento", "Em andamento 25%", "Em andamento 50%", "Em andamento 75%"].includes(status);
      try {
        if (emAndamento) {
          await atualizarProtocoloTarefa(idTarefa, { usuario_id: this.idUsuario, dtInicioReal: data, dtFimReal: null });
          if (tarefa) tarefa.dtInicioReal = data;
        } else if (status === "Concluído") {
          await atualizarProtocoloTarefa(idTarefa, { usuario_id: this.idUsuario, dtFimReal: data });
          if (tarefa) tarefa.dtFimReal = data;
        } else if (status === "Pendente") {
          await atualizarProtocoloTarefa(idTarefa, { usuario_id: this.idUsuario, dtInicioReal: null, dtFimReal: null });
          if (tarefa) tarefa.dtInicioReal = null; if (tarefa) tarefa.dtFimReal = null;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async definirInicioFimRealPlanodeAção(idBacklog, status) {
      const d = new Date();
      const data = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-");
      const tarefa = this.tarefas.find((item) => item.id === idBacklog);
      const emAndamento = ["Em andamento", "Em andamento 25%", "Em andamento 50%", "Em andamento 75%"].includes(status);
      try {
        if (emAndamento) {
          await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtInicioReal: data });
          if (tarefa) tarefa.dtInicioReal = data;
        } else if (status === "Concluído") {
          await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtFimReal: data });
          if (tarefa) tarefa.dtFimReal = data;
        } else if (status === "Pendente") {
          await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtInicioReal: null, dtFimReal: null });
          if (tarefa) tarefa.dtInicioReal = null; if (tarefa) tarefa.dtFimReal = null;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async editarBacklog(itemAlterado, idBacklog, novoValor) {
      try {
        const response = await atualizarSprintTarefa(idBacklog, {
          usuario_id: this.idUsuario,
          [itemAlterado]: novoValor,
        });
        const tarefa = this.tarefas.find((item) => item.id === idBacklog && item.tipo === 999);
        if (tarefa && response?.tarefa) {
          tarefa.logs_fim_previsto = response.tarefa.logs_fim_previsto ?? [];
        }
        if (itemAlterado === "status") {
          await this.definirInicioFimReal(idBacklog, novoValor);
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async definirInicioFimReal(idBacklog, status) {
      const now = new Date();
      const data = now.toISOString().split("T")[0] + " " + [now.getHours(), now.getMinutes(), now.getSeconds()].map((n) => String(n).padStart(2, "0")).join(":");
      const tarefa = this.tarefas.find((item) => item.id === idBacklog);
      const emAndamento = ["Em andamento", "Em andamento 25%", "Em andamento 50%", "Em andamento 75%"].includes(status);
      try {
        if (emAndamento) {
          await atualizarSprintTarefa(idBacklog, { usuario_id: this.idUsuario, dtFimReal: null, dtInicioReal: data });
          if (tarefa) tarefa.dtFimReal = null; if (tarefa) tarefa.dtInicioReal = data;
        } else if (status === "Concluído") {
          await atualizarSprintTarefa(idBacklog, { usuario_id: this.idUsuario, dtFimReal: data });
          if (tarefa) tarefa.dtFimReal = data;
        } else if (status === "Pendente") {
          await atualizarSprintTarefa(idBacklog, { usuario_id: this.idUsuario, dtInicioReal: null, dtFimReal: null });
          if (tarefa) tarefa.dtInicioReal = null; if (tarefa) tarefa.dtFimReal = null;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async baixarXML() {
      this.loadingXml = true;
      const payload = {
        dtInicio: this.periodoInicio,
        dtFim: this.periodoFim,
        idUser: this.usuarioTarefas,
        statusProjetoPa: this.statusOrigem,
        statusTarefa: this.statusTarefas,
      };
      try {
        await baixarRelatorioTarefasExcel(payload);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingXml = false;
      }
    },

    salvarFiltro() {
      try {
        const filtro = {
          usuarioTarefas: this.usuarioTarefas,
          periodoInicio: this.periodoInicio,
          periodoFim: this.periodoFim,
          statusTarefas: this.statusTarefas,
          statusOrigem: this.statusOrigem,
          origem: this.origem,
          buscarTarefasSemData: this.buscarTarefasSemData,
        };
        sessionStorage.setItem('gestaoTarefasFiltro', JSON.stringify(filtro));
      } catch (e) {
        if (process.env.NODE_ENV === 'development') console.warn('Falha ao salvar filtro', e);
      }
    },
    restaurarFiltro() {
      try {
        const raw = sessionStorage.getItem('gestaoTarefasFiltro');
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    async getTarefas() {
      this.loading = true;
      this.salvarFiltro();
      const payload = {
        dtInicio: this.periodoInicio,
        dtFim: this.periodoFim,
        idUser: this.usuarioTarefas,
        statusProjetoPa: this.statusOrigem,
        statusTarefa: this.statusTarefas,
      };
      try {
        const data = await listarTarefasUsuario(payload);
        this.tarefas = data.map((item) => ({
          ...item,
          tipo: item.tipo,
          id: item.id,
          nome: item.nome,
          descricao: item.descricao,
          status: item.status,
          HP: item.HP,
          dtFim: dataParaInput(item.dtFim) || null,
          dtFimReal: dataParaInput(item.dtFimReal) || null,
          dtInicio: dataParaInput(item.dtInicio) || null,
          responsavel_nome: item.responsavel_nome,
          codigo: item.codigo,
          pcm_codigo: item.pcm_codigo,
        }));

        const statusOrder = { Andamento: 1, Pendente: 2, Concluído: 3, Cancelada: 4 };
        this.tarefas.sort((a, b) => (statusOrder[a.status] || 0) - (statusOrder[b.status] || 0));

        const origemValores = this.origem.map((item) => item.valor);
        this.tarefas = this.tarefas.filter((tarefa) => origemValores.includes(tarefa.tipo));
        this.tarefasFiltradas = this.tarefas;
        this.aplicarOrdenacaoTarefas();
        this.somarHP();
        this.$nextTick(() => {
          const el = document.getElementById('tarefa-destaque');
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      } catch (error) {
        this.handleError(error, () => { this.loading = false; });
      } finally {
        this.loading = false;
      }
    },

    async carregarPermissoes() {
      const id = this.idUsuario;
      try {
        const dadosUsuario = await getDados(id);
        this.dadosUsuario = dadosUsuario;
        if (dadosUsuario.funcionalidade_id.includes(116)) {
          const data = await listarUsuarios();
          this.subordinados = data.map((i) => ({ usuario_id: i.id, nome: i.name }));
        } else if (dadosUsuario.funcionalidade_id.includes(137)) {
          const data = await listarUsuarios();
          const pessoaasEnvolvidas = this.setores
            .filter((i) => i.id === this.dadosUsuario?.setor[0] || this.dadosUsuario?.setor_responsavel?.includes(i.id))
            .flatMap((s) => s.pessoas)
            .map((p) => p.pessoa_id);
          this.subordinados = data.filter((p) => pessoaasEnvolvidas.includes(p.pessoa_id)).map((i) => ({ usuario_id: i.id, nome: i.name }));
        } else {
          const data = await listarSubordinadosPorResponsavel(id);
          this.subordinados = data;
        }
      } catch (error) {
        this.handleError(error);
        if (process.env.NODE_ENV === 'development') console.warn("Falha ao colher dados do usuario");
      }
    },

    async getSetores() {
      try {
        const response = await consultarSetores();
        this.usuarios = response.usuarios;
        this.setores = response.setores
      } catch (error) {
        this.handleError(error);
      }
    },

    ordenarLista(chaveColuna) {
      this.toggleOrdenacao(chaveColuna);
      this.aplicarOrdenacaoTarefas();
    },
    aplicarOrdenacaoTarefas() {
      const coluna = this.sortKey;
      if (!coluna) return;
      switch (coluna) {
        case "pcm_codigo":
          this.ordenarString(coluna);
          break;
        case "responsavel_nome":
          this.porStatus();
          break;
        case "status":
          this.porStatus();
          break;
        case "dtFim":
          this.porData(coluna);
          break;
        case "dtFimReal":
          this.porData(coluna);
          break;
        case "HP":
          this.porHP();
          break;
        default:
          break;
      }
    },

    ordenarString(coluna) {
      this.tarefasFiltradas.sort((a, b) => {
        const valorA = a[coluna] ?? "z";
        const valorB = b[coluna] ?? "z";

        if (this.sortOrder === 'asc') return valorA.localeCompare(valorB);
        return valorB.localeCompare(valorA);
      });
    },

    porData(coluna) {
      this.tarefasFiltradas.sort((a, b) => {
        const dataInicioA = new Date(a[coluna]);
        const dataInicioB = new Date(b[coluna]);
        if (this.sortOrder === 'asc') return dataInicioA - dataInicioB;
        return dataInicioB - dataInicioA;
      });
    },

    porStatus() {
      const order = {
        Andamento: 1,
        Pendente: 2,
        Concluído: 3,
        Cancelada: 4,
      };

      this.tarefasFiltradas.sort((a, b) => {
        const orderA = order[a.status] || 0;
        const orderB = order[b.status] || 0;
        if (this.sortOrder === 'asc') {
          if (orderA < orderB) return -1;
          if (orderA > orderB) return 1;
          return 0;
        }
        if (orderA > orderB) return -1;
        if (orderA < orderB) return 1;
        return 0;
      });
    },

    porHP() {
      this.tarefasFiltradas.sort((a, b) => {
        const orderA = a.HP ?? 0;
        const orderB = b.HP ?? 0;
        if (this.sortOrder === 'asc') {
          if (orderA < orderB) return -1;
          if (orderA > orderB) return 1;
          return 0;
        }
        if (orderA > orderB) return -1;
        if (orderA < orderB) return 1;
        return 0;
      });
    },
  },
};
</script>
<style>
.container {
  max-width: 1472px !important
}

.header {
  cursor: pointer;
}

.multiselect {
  box-sizing: content-box;
  display: block;
  position: relative;
  width: 100%;
  min-height: 40px;
  text-align: left;
}

.multiselect * {
  box-sizing: border-box;
}

.multiselect--active .multiselect__select {
  transform: rotateZ(180deg);
}

.multiselect__tags-wrap {
  display: inline;
}

.multiselect__tags {
  min-height: 48px;
  display: block;
  padding: 5px 20px 0 5px;
  border-radius: 6px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  font-size: 14px;
}

.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 23px 4px 10px;
  border-radius: 14px;
  margin-right: 3px;
  color: var(--cor-fonte);
  line-height: 1;
  background: transparent !important;
  border: 1px solid var(--cor-separador);
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.multiselect__tag-icon {
  cursor: pointer;
  margin-left: 7px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: initial;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.multiselect__tag-icon::after {
  content: "×";
  color: var(--cor-fonte-fraca);
  font-size: 14px;
}

.multiselect__tag-icon:focus::after,
.multiselect__tag-icon:hover::after {
  color: red;
}

.multiselect__select {
  line-height: 16px;
  display: block;
  position: absolute;
  box-sizing: border-box;
  width: 40px;
  height: 38px;
  right: 1px;
  top: 1px;
  padding: 4px 8px;
  margin: 0;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.multiselect__select::before {
  position: relative;
  right: 0;
  top: 65%;
  margin-top: 4px;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: var(--cor-fonte) transparent transparent transparent;
  content: "";
}

.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: var(--cor-bg);
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid var(--cor-separador);
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 50;
  -webkit-overflow-scrolling: touch;
}

.multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  min-width: 100%;
  vertical-align: top;
}

.multiselect__content::-webkit-scrollbar {
  display: none;
}

.multiselect__element {
  display: block;
}

.multiselect__option {
  display: block;
  padding: 12px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}

.multiselect__option::after {
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}

.multiselect__option--highlight {
  background: var(--cor-primaria-fraca) !important;
  outline: none;
  color: var(--cor-fonte);
}

.multiselect__option--highlight::after {
  content: attr(data-select);
  background: var(--cor-primaria) !important;
  color: var(--cor-fonte);
}

.multiselect-enter-active,
.multiselect-leave-active {
  transition: all 0.15s ease;
}

.multiselect-enter,
.multiselect-leave-active {
  opacity: 0;
}

/* Estilo global desta tela: classes prefixadas para não vazar para outros componentes. */
.gestao-fim-previsto {
  display: flex;
  flex-direction: column;
}

/* Espaço espelhado acima do input: a linha cresce e o input segue centralizado. */
.gestao-fim-previsto:has(.gestao-fim-previsto-original) {
  padding-top: 28px;
  gap: 4px;
}

/* Sem a margem negativa da tabela, senão o chip invade a altura visual do campo. */
.gestao-fim-previsto:has(.gestao-fim-previsto-original) input[type="date"] {
  margin: 0;
}

.gestao-fim-previsto-original {
  align-self: flex-start;
  margin: 0;
  line-height: 20px;
  white-space: nowrap;
}

/* Destaque da tarefa clicada ao abrir a partir do portal */
tr.tarefa-destaque {
  background-color: var(--cor-primaria-fraca) !important;
  box-shadow: inset 0 0 0 2px var(--cor-primaria);
}
</style>
